<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
$(document).ready(function() {
   $('.allergens-box').click(function() {
    $(this).toggleClass('acc-active');
    $(this).siblings('.feature-box').toggleClass('active');
  });

  $('.featured-products__slider').slick({
    infinite: true,
    dots: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: '<div class="arrow-right"><img src="//waldenfarms.com/cdn/shop/t/29/assets/circle-chevron-right-solid.png?v=82522999196213844781745262500"></div>',
    prevArrow: '<div class="arrow-left"><img src="//waldenfarms.com/cdn/shop/t/29/assets/circle-chevron-left-solid.png?v=136056545354490234421745262500"></div>'
  });

  $('.featured-collection2__slider').slick({
    infinite: true,
    dots: false,
    arrows: false,
    slidesToShow: 2,
    slidesToScroll: 1
  });
  $(".featured-collection2__arrows .arrow-left").click(function(){
    $('.featured-collection2__slider').slick('slickPrev');
  });
  $(".featured-collection2__arrows .arrow-right").click(function(){
    $('.featured-collection2__slider').slick('slickNext');
  });

  $(".featured-products__thumbnail").click(function(){
    $(".featured-products__thumbnail").removeClass("active");
    $(this).addClass("active");
    var i = $(this).data("index");
    var color = $(this).data("color");
    var section = $(this).data("section");
    $('.featured-products__slider').slick('slickGoTo', i);
    $('#section-'+section).css('background', color);
  });

  $('.featured-products__slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $(".featured-products__thumbnail").removeClass("active");
        $(".featured-products__thumbnail[data-index='"+nextSlide+"']").addClass("active");
        var color = $(".featured-products__thumbnail[data-index='"+nextSlide+"']").data("color");
        var section = $(".featured-products__thumbnail[data-index='"+nextSlide+"']").data("section");
        $('#section-'+section).css('background', color);

    $(".featured-products__slide-sticker .sticker").hide();
    $(".featured-products__slide-sticker .sticker[data-index='"+nextSlide+"']").show();
  });
});

  /*
$('button#product-add-to-cart').on('click',function(){
  var SellingPlanId = $(this).closest("form").find('select option:selected').val();
  var ProductId = $(this).closest("form").find('select').attr('data-pid');
  console.log('sellingPlanId', SellingPlanId);
  console.log('ProductId', ProductId);
    data = {
      "id": ProductId,
      "quantity": 1,
      "selling_plan": SellingPlanId
    }
  
  setTimeout(function() {
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
       // window.location.href = '/cart'; 
      }
    });
    }, 2000);
  });

*/
/* Custom plus - minus qty */
jQuery(document).ready(function(){
      $("body").on("click", ".qtyplus", function (e) { 
        e.preventDefault();
        fieldName = $(this).attr('field');
        var cur_qty = $(this).closest('.quantity__container').find('input[name='+fieldName+']');
        var currentVal = parseInt($(cur_qty).val());
        var closest_qty = $(this).closest('.quantity__container').find('input[name='+fieldName+']');
        if (!isNaN(currentVal)) {
         
            $(closest_qty).val(currentVal + 1);
        } else {
            $(closest_qty).val(1);
        }
    });
    $("body").on("click", ".qtyminus", function (e) { 
        e.preventDefault();
        fieldName = $(this).attr('field');
         var cur_qty = $(this).closest('.quantity__container').find('input[name='+fieldName+']');
        var currentVal = parseInt($(cur_qty).val());
      var closest_qty = $(this).closest('.quantity__container').find('input[name='+fieldName+']');
        if (!isNaN(currentVal) && currentVal > 1) {
            $(closest_qty).val(currentVal - 1);
        } else {
          $(closest_qty).val(1);
        }
    });
});
// $(document).ready(function() {
//       $('.read_more').click(function(event) {
//         $(this).toggleClass("less");
//         event.preventDefault();
//         if ($(this).hasClass("less")) {
//           $(this).html("Read Less");
//           $(this).parent().find(".more_text").show();
//         } else {
//           $(this).html("... Read More");
//           $(this).parent().find(".more_text").hide();
//         }
//       });
//     });
/* Contact page tab */
$('#contact-tabs-nav li:first-child').addClass('active');
$('.contact-tab-content').hide();
$('.contact-tab-content:first').show();

$('#contact-tabs-nav li').click(function(e) {
  e.preventDefault(); // Prevent the default behavior of the anchor tag
  
  $('#contact-tabs-nav li').removeClass('active');
  $(this).addClass('active');
  $('.contact-tab-content').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
});

/* Wholesale popup */
$('.wholesale-modal-toggle').on('click', function(e) {
  e.preventDefault();
  $('.wholesale-modal').toggleClass('is-visible');
});

$('.card_plus a').on('click', function(e) {
  e.preventDefault();
  $(this).toggleClass('active');
  var get_id = $(this).attr('href');
  var get_id_var = '.product[data-id="'+ get_id +'"]';
  $(get_id_var).toggleClass('active');

});

/* Pagination multiple product */
jQuery(document).ready(function(){
var items = $(".card_product_main .product");
    var numItems = items.length;
    var perPage = 20;

    items.slice(perPage).hide();

    $('#pagination-ingredients-container').pagination({
        items: numItems,
        itemsOnPage: perPage,
        prevText: "&laquo;",
        nextText: "&raquo;",
        onPageClick: function (pageNumber, event) {
            event.preventDefault();
            var showFrom = perPage * (pageNumber - 1);
            var showTo = showFrom + perPage;
            items.hide().slice(showFrom, showTo).show();
             $('html, body').animate({
               scrollTop:$(".card_product_main").offset().top - 200
            }, 'slow');
          }
     }); 
});

$('a.nutrition-facts').click(function(event){
    $('html, body').animate({
        scrollTop: $( $.attr(this, 'href') ).offset().top
    }, 500);
    event.preventDefault();
});

/* Blog Receipes custom print */
document.querySelector("#print").addEventListener('click', ()=>{
  const annouceArr = document.querySelector("#shopify-section-announcement-bar")
  annouceArr.classList.add("dn-print");
  
  const headerArr = document.querySelector("#shopify-section-header-02")
  headerArr.classList.add("dn-print");
  
  const warpprfooterArr = document.querySelector(".wrapper-footer");
  warpprfooterArr.classList.add("dn-print");

  const policesArr = document.querySelector(".policies-block");
  policesArr.classList.add("dn-print");

  const footerArr = document.querySelector("#shopify-section-footer")
  footerArr.classList.add("dn-print");
  
  const socialArr = document.querySelector(".article-social");
  socialArr.classList.add("dn-print");

  const paginationArr = document.querySelector(".article__pagination");
  paginationArr.classList.add("dn-print");

  const breadArr = document.querySelector(".breadcrumb-container");
  breadArr.classList.add("dn-print");

  const commentArr = document.querySelector(".article-template__comment-wrapper");
  commentArr.classList.add("dn-print");
  
  window.print();
});



